import { DOCUMENT } from '@angular/common';
import {
  Injector,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { ConsentService } from '@boels/helpers';
import { AppConfig } from '@boels/models';

export function initConsentEvents(
  injector: Injector,
  document: Document,
  environment: AppConfig,
): () => void {
  return () => {
    const consentState = document.createElement('script');
    consentState.id = 'default-consent-state';
    consentState.setAttribute('data-cookieconsent', 'ignore');
    consentState.type = 'text/javascript';
    consentState.src = 'assets/scripts/defaultConsentState.js';
    consentState.defer = true;
    document.head.appendChild(consentState);

    const cookieBot = document.createElement('script');
    cookieBot.id = 'Cookiebot';
    cookieBot.src =
      'https://consent.cookiebot.com/uc.js?cbid=2ff6c9e9-d719-4522-89b6-4eb334e5fd61';
    cookieBot.type = 'text/javascript';
    cookieBot.setAttribute('data-consentmode-defaults', 'disabled');
    cookieBot.defer = true;
    document.head.appendChild(cookieBot);

    const consentService: ConsentService = injector.get(ConsentService);
    consentService.initConsentEventManually();
    consentService.initConsentEventHandler();

    const isEnvironmentLocal =
      !environment.production && environment.baseUrl.includes('localhost');

    if (isEnvironmentLocal) {
      consentService.setCookieConsentForLocalhost();
    } else {
      consentService.injectJsWithConsent(
        'convert-ab-testing',
        '//cdn-4.convertexperiments.com/v1/js/10047417-100416119.js?environment=production',
        'necessary',
      );
    }
  };
}

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initConsentEvents(
        inject(Injector),
        inject<Document>(DOCUMENT),
        inject<AppConfig>('ENVIRONMENT' as any),
      );
      return initializerFn();
    }),
  ],
})
export class ConsentModule {}
